// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2ysKD","boxTitle":"Qualiphy_boxTitle__56eF_","box":"Qualiphy_box__3Kpit","toggleWrap":"Qualiphy_toggleWrap__vNN9b"};